<template>
  <!-- v-intersect="onintersect" -->
  <div
    class="mpwaggon"
    :style="`left: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + (var(--workpackage_width) + 8px) * var(--taktplan_zoom) + (${multiproject_calendar.lookup[waggon.takt_start_date]} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom)))`"
    >
    <Waggon
      v-if="show_waggon"
      :duration="waggon.length"
      :workpackage_count="waggon.tworkpackages.length"
      >
      <template #content>
        <MPWorkpackage
          v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
          :key="`workpackage${workpackage.id}`"
          :workpackage="workpackage"
          :waggon="waggon"
        />
      </template>
    </Waggon>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

import MPWorkpackage from '@/views/MultiProject/MPWorkpackage.wrapper.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';

  export default {
    props: ['waggon'],
    components: {
      MPWorkpackage,
      Waggon
    },
    data: () => ({
      show_waggon: true,
    }),
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapState('MultiProject', [
        'multiproject_calendar',
      ]),
    },
    methods: {
      onintersect(entries, observer, isIntersecting) {
        if (isIntersecting) {
          this.show_waggon = true
        } else {
          this.show_waggon = false
        }
      },
    }
  }
</script>
<style>
  .mpwaggon {
    position: absolute;
  }
</style>
